export default __webpack_public_path__ + "static/media/placeholder-female.2dd11427.jpg";